<template>
  <model-form
    ref="modelForm"
    :model="journalEntry"
    modal-type="modal"
  >
    <div>
      <div class="row q-gutter-md q-mb-md">
        <q-input
          :model-value="journalEntry.date"
          class="col"
          label="Date"
          readonly
        />
        <q-input
          :model-value="journalEntry.isManual"
          class="col"
          label="Manual"
          readonly
        />
        <q-input
          :model-value="journalEntry.isContra"
          class="col"
          label="Contra"
          readonly
        />
      </div>
      <div class="row q-gutter-md q-mb-md">
        <q-input
          :model-value="journalEntry.accountSource && journalEntry.accountSource.account && journalEntry.accountSource.account.name"
          class="col"
          label="Account"
          readonly
        />
        <q-input
          :model-value="journalEntry.accountSource && journalEntry.accountSource.account && journalEntry.accountSource.account.glCode"
          class="col"
          label="GL Code"
          readonly
        />
        <q-input
          :model-value="journalEntry.accountSource && journalEntry.accountSource.name"
          class="col"
          label="Account Source"
          readonly
        />
      </div>
      <div class="row q-gutter-md q-mb-md">
        <q-input
          :model-value="journalEntry.description"
          class="col"
          label="Description"
          readonly
        />
      </div>
      <div class="row q-gutter-md q-mb-md">
        <q-input
          :model-value="journalEntry.amount"
          class="col"
          label="Amount"
          :prefix="currentCircuit.localeCurrencySymbol"
          readonly
        />
      </div>
    </div>
  </model-form>
</template>

<script>
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'

export default {
  name: 'JournalEntryForm',
  components: {
    ModelForm
  },
  configuration: ['currentCircuit'],
  models: {
    journalEntry: {
      accountSource: {
        account: true
      }
    }
  },
  methods: {
    show (model, initialData) {
      this.$refs.modelForm.show(model, initialData)
    }
  }
}

</script>

<style lang="scss" scoped>
</style>
